import { render, staticRenderFns } from "./RemoteManagement.vue?vue&type=template&id=211ba645&scoped=true&"
import script from "./RemoteManagement.vue?vue&type=script&lang=js&"
export * from "./RemoteManagement.vue?vue&type=script&lang=js&"
import style0 from "./RemoteManagement.vue?vue&type=style&index=0&id=211ba645&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211ba645",
  null
  
)

export default component.exports